/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DashboardLocalizedCopyDto } from './dashboard-localized-copy-dto';
import { CompareTo } from './compare-to';


export interface UpdateDashboardDto { 
    /**
     * Human-readable dashboard name in English; users see it when i18n has no entry for their language. At most 80 characters.
     */
    name?: string;
    /**
     * Optional longer dashboard description or usage note, in English.
     */
    description?: string;
    /**
     * The dashboard\'s name and description in languages other than English, keyed by two-letter lowercase language code, at most 20 languages, for example {\"de\": {\"name\": \"Umsatzübersicht\", \"description\": \"Umsatz je Filiale\"}}. English goes in the plain name and description; an en key is rejected. A client shows the entry for the viewer\'s language, else the plain name and description. Omitted keeps the stored translations, null removes them, an object replaces the whole map. A rename should send the new translations too, so the old ones do not go stale.
     */
    i18n?: { [key: string]: DashboardLocalizedCopyDto; } | null;
    /**
     * Dashboard lifecycle status.
     */
    status?: UpdateDashboardDto.StatusEnum;
    /**
     * Freeform dashboard layout state owned by the UI.
     */
    layout?: { [key: string]: any; };
    /**
     * Position of this dashboard among the Home tabs; null takes it off Home.
     */
    homeOrder?: number | null;
    /**
     * Apply filter changes as soon as they are made (true) or wait for an Apply button (false).
     */
    autoApplyFilters?: boolean;
    /**
     * The dashboard\'s default Compare to; null turns it Off, omitted leaves it as it is. What every count, amount and percentage tile compares its total with: previous_period (N whole months, quarters, years or weeks with the N before them, a month, quarter, year or week so far with the same days of the one before, any other range with as many days just before it) or same_period_last_year (the same dates a year earlier, 29 February as 28 February; whole months, quarters or years with the same units to their last day). null is Off. Trend and chart tiles are not affected.
     */
    compareTo?: CompareTo | null;
}
export namespace UpdateDashboardDto {
    export const StatusEnum = {
        Draft: 'draft',
        Published: 'published',
        Archived: 'archived'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


